import React from 'react';


import FormElement from '../index';
import FormFieldError from '../../FormFieldError';
import TextInput from '../../Input/TextInput';


function FormTextInput(props) {

    return (
        <FormElement {...props}>
            <TextInput {...props}/>
            <FormFieldError error={props.error}/>
        </FormElement>
    );
}


FormTextInput.propTypes = {
    ...FormElement.propTypes,
    ...TextInput.propTypes
};

FormTextInput.defaultProps = {
    ...FormElement.defaultProps,
    ...TextInput.defaultProps
};


export default FormTextInput;
